import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HemroFullscreenComponent } from '@hemro/components/fullscreen/fullscreen.component';


@NgModule({
    declarations: [
        HemroFullscreenComponent
    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        CommonModule
    ],
    exports     : [
        HemroFullscreenComponent
    ]
})
export class HemroFullscreenModule
{
}
